import { motion } from "framer-motion";
import { MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const CITIES = ["Portland", "Hillsboro", "Clackamas", "Beaverton", "Tualatin"];

export function ServiceArea() {
  return (
    <section id="service-area" data-testid="service-area-section" className="py-24 lg:py-32 bg-accent scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="overflow-hidden rounded-md border border-white/10">
            <img
              src="https://images.unsplash.com/photo-1603312504738-3dd0fdaff23b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxwb3J0bGFuZCUyMG9yZWdvbiUyMHNreWxpbmV8ZW58MHx8fHwxNzg1NzY3NDgyfDA&ixlib=rb-4.1.0&q=85"
              alt="Portland, Oregon skyline"
              loading="lazy"
              className="w-full h-full object-cover aspect-[4/3]"
              data-testid="service-area-image"
            />
          </div>
          <motion.div
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          >
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-primary mb-4">
              Service Area
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl tracking-tight leading-tight font-bold text-white">
              Proudly Serving Greater PDX
            </h2>
            <p className="text-base text-white/70 mt-4 leading-relaxed">
              Based in the Portland metro, we bring professional chimney and masonry
              work to homeowners across the region.
            </p>
            <div className="flex flex-wrap gap-3 mt-8" data-testid="service-area-cities">
              {CITIES.map((city) => (
                <a
                  key={city}
                  href={`/services/${city.toLowerCase()}`}
                  data-testid={`city-chip-${city.toLowerCase()}`}
                  className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white text-sm font-semibold px-4 py-2 rounded-md transition-colors"
                >
                  <MapPin className="w-4 h-4 text-primary" strokeWidth={2} />
                  {city}, OR
                </a>
              ))}
            </div>
            <p className="text-sm text-white/60 mt-6">
              Just outside these areas? Give us a call — we often accommodate nearby communities.
            </p>
            <Button
              asChild
              data-testid="service-area-call-button"
              className="btn-press mt-8 bg-primary hover:bg-[#A93A24] text-white font-bold rounded-md h-12 px-8"
            >
              <a href="tel:+19712553874" className="flex items-center gap-2">
                <Phone className="w-4 h-4" strokeWidth={2} />
                Call 971-255-3874
              </a>
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
